/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { mobileOrderItemModifierCreateSchema } from "./mobileOrderItemModifierCreateSchema.ts";

export const mobileOrderItemGroupModifierCreateSchema = mobileOrderItemModifierCreateSchema;
